module.exports = __webpack_public_path__ + "static/media/img_info.2b9db269.jpeg";